import { useState, useEffect, createContext, useMemo } from "react";
import { useSelector } from "react-redux";
import { Bounce, toast } from 'react-toastify';


export const SSEContext = createContext(null);


export const SSEProvider = ({ children }) => {

  const [SSEevents, setSSEEvents] = useState({
    commentsNotification: [],
    activeNotification: []
  });

  const { user } = useSelector((state) => state.app.datastate);



  useEffect(() => {
    // Only connect to SSE if user is logged in
    if (!user?._id) {
      return;
    }

    const baseURL = import.meta.env.VITE_ANOKYE_API_URL || 'http://localhost:5001';
    const eventSource = new EventSource(`${baseURL}/anokye/notifications?userId=${user._id}`)
    //Any event you want to listen to should be added here
    eventSource.addEventListener("newComment", (event) => {
      const data = JSON.parse(event.data);
      setSSEEvents((prev) => ({
        ...prev,
        commentsNotification: [...prev.commentsNotification, data],
      }));
    });

    eventSource.addEventListener("active", (event) => {
      const data = JSON.parse(event.data);
      setSSEEvents((prev) => ({
        ...prev,
        activeNotification: [...prev.activeNotification, data],
      }));
    });



    eventSource.onerror = (err) => {
      eventSource.close();
    };

    return () => eventSource.close();
  }, [user?._id])
  const value = useMemo(() => SSEevents, [SSEevents]);
  return (
    <SSEContext.Provider value={value}>
      {children}
    </SSEContext.Provider>
  )
}